const translations = {
  en: {
    title: 'Payout methods',
    expressDeposit: 'EXPRESS DEPOSIT',
    expressDisabledTitle: 'You need to deposit first to have this option available',
    useOtherDeposit: 'USE OTHER DEPOSIT METHODS',
    min: 'Min',
    max: 'Max',
    noLimit: 'No Limit',
    back: 'BACK',
    error: 'Error',
    errorGettingLimits: 'Error getting payout limits info: ',
  },
  es: {
    title: 'Métodos de retiro',
    expressDeposit: 'DEPÓSITO EXPRESS',
    expressDisabledTitle: 'Necesita depositar primero para tener esta opción disponible',
    useOtherDeposit: 'USAR OTROS MÉTODOS DE DEPÓSITO',
    min: 'Mín',
    max: 'Máx',
    noLimit: 'Sin Límite',
    back: 'ATRÁS',
    error: 'Error',
    errorGettingLimits: 'Error al obtener información de límites de retiro: ',
  },
  pt: {
    title: 'Métodos de saque',
    expressDeposit: 'DEPÓSITO EXPRESS',
    expressDisabledTitle: 'Você precisa depositar primeiro para ter esta opção disponível',
    useOtherDeposit: 'USAR OUTROS MÉTODOS DE DEPÓSITO',
    min: 'Mín',
    max: 'Máx',
    noLimit: 'Sem Limite',
    back: 'VOLTAR',
    error: 'Erro',
    errorGettingLimits: 'Erro ao obter informações de limites de saque: ',
  },
}

export default translations
